import React from 'react';

import './collaborationSection.css';
import './collaborationSectionMobile.css';

const CollaborationSection = (props) => {
  const pageContent = props['content'];
  return <section className="collaboration" id="collaboration">
  <div className="title">{pageContent['title']}</div>
  <div className="icons">
    {
      pageContent['icons'].map((icon, idx) => {
        return <div className="icon" key={idx}>
          <img src={icon} alt="" />
        </div>;
      })
    }
  </div>
</section>;
}

export default CollaborationSection;
